import { createSelector } from "reselect";

import getUserAgent from "./getUserAgent";

export default createSelector([getUserAgent], (userAgent) => userAgent.isIE);
